import React from 'react';
import { Terminal } from 'lucide-react';

const ConsoleSection = () => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            Rich console output
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See everything your agent does, right in your terminal.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl overflow-hidden shadow-2xl">
          <div className="flex items-center justify-between px-6 py-3 bg-muted border-b border-border">
            <div className="flex items-center space-x-2">
              <Terminal className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium text-muted-foreground">Console Output</span>
            </div>
            <div className="flex space-x-2">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
          </div>
          <div className="p-8 bg-black/95 text-white font-mono text-sm">
            <pre className="overflow-x-auto">
              <code>
                {"============================================================\n"}
                <span className="text-blue-400">📊 AGENT RUN SUMMARY</span>
                {"\n"}
                <span className="text-gray-400">Run ID:     </span><span className="text-yellow-400">550e8400-e29b-41d4-a716-446655440000</span>
                {"\n"}
                <span className="text-gray-400">Agent:      </span><span className="text-green-400">my-research-agent</span>
                {"\n"}
                <span className="text-gray-400">Status:     </span><span className="text-green-400">completed</span>
                {"\n"}
                <span className="text-gray-400">Duration:   </span><span className="text-cyan-400">12,340ms</span>
                {"\n"}
                <span className="text-gray-400">Tokens:     </span><span className="text-cyan-400">15,230 in / 3,200 out</span>
                {"\n"}
                <span className="text-gray-400">Cost:       </span><span className="text-yellow-400">$0.0936</span>
                {"\n\n"}
                <span className="text-blue-400">📦 Tool Usage:</span>
                {"\n"}
                <span className="text-gray-400">• WebSearch: </span><span className="text-cyan-400">3x</span><span className="text-gray-400"> (</span><span className="text-cyan-400">1200ms</span><span className="text-gray-400">) </span><span className="text-green-400">[✓]</span>
                {"\n"}
                <span className="text-gray-400">• Read: </span><span className="text-cyan-400">2x</span><span className="text-gray-400"> (</span><span className="text-cyan-400">50ms</span><span className="text-gray-400">) </span><span className="text-green-400">[✓]</span>
                {"\n"}
                <span className="text-gray-400">• Write: </span><span className="text-cyan-400">1x</span><span className="text-gray-400"> (</span><span className="text-cyan-400">30ms</span><span className="text-gray-400">) </span><span className="text-green-400">[✓]</span>
                {"\n"}
              </code>
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsoleSection;